import { UnknownProcessorError } from './errors.js';

var E_UNKNOWN_ENTITY = new SyntaxError("Unknown entity");

function identity(x) {
  return x;
}

function isLiteral(body) {
  return body.startsWith('"') && body.endsWith('"');
}

function stringify(processors, data, input) {
  /* istanbul ignore next: type safety */
  if (input.type !== "translation") {
    throw E_UNKNOWN_ENTITY;
  }

  var result = "";

  for (var i = 0; i < input.body.length; i++) {
    var entity = input.body[i];

    switch (entity.type) {
      case "string":
        {
          result += entity.body;
          break;
        }

      case "variable":
        {
          var processor = entity.processor ? processors[entity.processor] : identity;

          if (typeof processor === "undefined") {
            throw new UnknownProcessorError(entity.processor);
          }

          var value = isLiteral(entity.body) ? entity.body.slice(1, -1) : data[entity.body];

          if (typeof value === "undefined") {
            result += "{{".concat(entity.body, "}}");
          } else {
            result += processor(value, data);
          }

          break;
        }

      /* istanbul ignore next: type safety */

      default:
        {
          throw E_UNKNOWN_ENTITY;
        }
    }
  }

  return result;
}

export { stringify };
